module.exports = __webpack_public_path__ + "img/pulse_logo_small.c234fb9a.png";